import script from "./PDFData.vue?vue&type=script&lang=js"
export * from "./PDFData.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__